import { Link } from "react-router-dom";
import { TMVLogo } from "./TMVLogo";
import { useLanguage } from "@/contexts/LanguageContext";

export const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-muted border-t border-border">
      <div className="container mx-auto px-6 lg:px-8 py-12">
        <div className="flex flex-col md:flex-row justify-between items-start gap-8">
          <div className="max-w-sm">
            <TMVLogo className="mb-4" />
            <p className="text-muted-foreground leading-relaxed">{t("footer.description")}</p>
          </div>
          <div className="flex gap-12">
            <div>
              <h3 className="font-semibold mb-4">{t("footer.platform")}</h3>
              <ul className="space-y-3">
                <li><Link to="/how-it-works" className="text-muted-foreground hover:text-foreground transition-colors uppercase">{t("footer.howItWorks")}</Link></li>
                <li><Link to="/what-does-it-mean" className="text-muted-foreground hover:text-foreground transition-colors uppercase">{t("footer.whatDoesItMean")}</Link></li>
                <li><Link to="/what-is-deadstock-fabric" className="text-muted-foreground hover:text-foreground transition-colors uppercase">What is deadstock?</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="font-semibold mb-4">{t("footer.company")}</h3>
              <ul className="space-y-3">
                <li><Link to="/about" className="text-muted-foreground hover:text-foreground transition-colors uppercase">{t("footer.aboutHidnstock")}</Link></li>
                <li><Link to="/contact" className="text-muted-foreground hover:text-foreground transition-colors uppercase">{t("footer.contact")}</Link></li>
                <li><Link to="/newsletter" className="text-muted-foreground hover:text-foreground transition-colors uppercase">{t("footer.newsletter")}</Link></li>
                <li><Link to="/press" className="text-muted-foreground hover:text-foreground transition-colors uppercase">{t("footer.press")}</Link></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="border-t border-border mt-10 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-muted-foreground text-sm">{t("footer.rights")}</p>
          <p className="text-muted-foreground text-sm mt-2 md:mt-0">{t("footer.tagline")}</p>
        </div>
      </div>
    </footer>
  );
};
